import { createAsyncAction, createReducer} from 'typesafe-actions'
import { END } from 'redux-saga'
import { put, call, takeEvery, all } from 'redux-saga/effects';
import * as api from '../lib/api/archives'

export type archiveEmail = {
  id:number,
  listId:number,
  subject:string,
  permanentLink:string,
  sentTime:string
}

export type archiveEmailPayloadType = archiveEmail[]

export type getArchiveEmailState ={
  data: archiveEmailPayloadType
  loading : boolean,
  error: boolean
}

export const getArchiveEmail = createAsyncAction(
  'GET_ARCHIVE_EMAIL',
  'GET_ARCHIVE_EMAIL_SUCCESS',
  'GET_ARCHIVE_EMAIL_FAILURE',
)<string, any, Error>();

type archiveEmailAction = ReturnType<typeof getArchiveEmail.request>

const initialState: getArchiveEmailState = {
  data:[],
  loading:false,
  error:false,
}

function* getArchiveEmailSaga(action:archiveEmailAction):Generator{
  try {
    const response:any = yield call(
      api.getArchivedEmails,
      action.payload
    )
    yield put(getArchiveEmail.success(response.data))
  } catch (e) {
    yield put(getArchiveEmail.failure(e))
  }
}

export function* archiveEmailSaga(){
  yield all([takeEvery(getArchiveEmail.request, getArchiveEmailSaga)])
}

export const archiveEmail = createReducer<
  getArchiveEmailState,
  ReturnType<typeof getArchiveEmail.request>|
  ReturnType<typeof getArchiveEmail.success>|
  ReturnType<typeof getArchiveEmail.failure>|
  END
>(initialState)
  .handleAction(
    getArchiveEmail.request,
    (state:getArchiveEmailState,action:{payload:string}
      )=>({
        ...state,
        loading: true,
        error: false,
      })
  )
  .handleAction(
    getArchiveEmail.success,
    (state:getArchiveEmailState,action:{payload:archiveEmailPayloadType})=>({
      ...state,
      loading: false,
      data:action.payload,
    })
  )
  .handleAction(
    getArchiveEmail.failure,
    (state:getArchiveEmailState,action:{payload:Error})=>({
      ...state,
      loading:false,
      error:true,
    })
  )

  export default archiveEmail